/**
 * Intacct modules
 */
export const modules = {
  /** Projects */
  pa: 'pa',
  /** Time and expenses */
  ee: 'ee',
} as const;
